import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./FeaturesSection3.scss";
import { useMediaQuery } from 'react-responsive';

function FeaturesSection3(props) {
  const items = [
    {
      title: "REST API post-v3.6",
      buttonTitle: "REST API Docs",
      buttonIcon: "fas fa-book",
      link: "https://edzlabs.github.io/pds-slatedocs-web/",
      body: "A comprehensive REST API Reference site for the current versions of the PDS API, including all endpoints, parameters and sample code. Details latest API releases on Production/PDSAPI networks and well as in-development versions on Beta network.",
      footer: <strong>PW: Z3tonium</strong>,
      image: "docs.svg",
    },
    {
      title: "REST/RPC API Docs pre-v3.6",
      buttonTitle: "Legacy Docs",
      buttonIcon: "fas fa-book",
      link: "http://docs-review.dase.io/",
      body: "Docs and API Reference with use cases, release notes and guides for deprecated DASE/API versions.",
      footer: <strong>User: developer, PW: z3tonium</strong>,
      image: "legacy_docs.svg",
    },
    {
      title: "Developer support center",
      buttonTitle: "Helpdesk",
      buttonIcon: "fas fa-question-circle",
      link: "/helpdesk",
      body: "Submit support tickets to the PDS team for help with questions and issues related to the API, DASE, and/or Apps.",
      image: "/helpdesk_icon.svg",
    },
    {
      title: "NPM library (v3.7.55) for PDS API",
      buttonTitle: "Client Library",
      buttonIcon: "fab fa-npm",
      link: "https://www.npmjs.com/package/dsd-client-conn-lib",
      body: "Client library for calling PDS API server endpoints from Node.js",
      image: "nodejs_logo.svg",
    },
    {
      title: "Żetonium testnet faucet",
      buttonTitle: "Faucet",
      buttonIcon: "fas fa-faucet",
      link:"/faucet",
      body: "Utility tool for developers using the different Żetonium testnets. Request balance transfer and/or credit line for Żetons on PDSAPI, Beta and Acceptance networks.",
      image: "zetonium_logo.svg",
    },
    {
      title: "Sample code for SATs and pNFTs",
      buttonTitle: "SAT JS Library",
      buttonIcon: "fab fa-github",
      link: "https://github.com/edzlabs/sampler",
      body: "Reference code for minting SATs and exporting pNFTs via the PDS API.",
      image: "js_logo.svg",
    },
    {
      title: "Sample code for PDS API",
      buttonTitle: "Elixir Library",
      buttonIcon: "fab fa-github",
      link: "https://github.com/edzlabs/SAT_use_cases_REST",
      body: "Reference code for general PDS API functionality in Elixir.",
      image: "elixir_logo.svg",
    },

  ];

  const isSmallMobile = useMediaQuery({ query: '(max-width: 440px)' });
  const btnSize = isSmallMobile ? 'is-normal' : 'is-large'

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          link={props.link}
          spaced={true}
          className="has-text-centered"
        />
        <div className="FeaturesSection3__box box">
          <div className="FeaturesSection3__columns columns is-multiline is-centered is-gapless">
            {items.map((item, index) => (
              <div
                className={
                  "FeaturesSection3__column column" +
                  (props.columns === 1 ? " is-full" : "") +
                  (props.columns === 2 ? " is-half" : "") +
                  (props.columns === 3 ? " is-one-third" : "") +
                  (props.columns === 4 ? " is-one-quarter" : "") +
                  (props.columns === 7 ? " is-one-third" : "")
                }
                key={index}
                style={{ margin: "20px auto", display: "block", border: "solid #132348 2px", borderRadius: "10px" }}
                >
                <div className="FeaturesSection3__item has-text-centered" >
                    <a className={`button ${btnSize} is-link is-hovered glow-on-hover`}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    <br />
                      <span class="icon is-small">
                        <i class={item.buttonIcon}></i>
                      </span>
                      <span className="FeaturesSection3__buttonTitle">{item.buttonTitle}</span>
                    </a>
                    <div className="FeaturesSection3__image-container">
                      <figure className="FeaturesSection3__image image is-4by3">
                        <img src={item.image} alt={item.title} />
                      </figure>
                    </div>
                    <h1 className="title is-4 is-spaced">
                      {item.title}
                    </h1>
                    <h2 className="subtitle is-6">{item.body}</h2>
                    {
                      item.footer && <h2 className="subtitle is-6">{item.footer}</h2>
                    }
                  </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection3;

